import React from 'react'
import toClass from 'recompose/toClass'
import { Constants } from 'utils/constants'
import { Modal, Form, Input, Icon, Alert } from 'antd'

const FormItem = Form.Item

const ChangeCallbackUriComponent = (props: any) => {
  const { form, editingRecord, loading, ...rest } = props
  const { getFieldDecorator } = form
  return (
    <div>
      <Modal
        centered
        title="Change the app callback url"
        okText="Change"
        okButtonProps={{ loading }}
        {...rest}>
        <Form layout="vertical">
          <FormItem label="New callback uri">
            {getFieldDecorator('OverrideCallbackUri', {
              rules: [
                {
                  required: true,
                  message: 'Provide a valid url',
                  pattern: Constants.URL_REGEX
                }
              ]
            })(<Input type="email" prefix={<Icon type="dribbble" style={{ color: '#dddddd' }} />}/>)}
          </FormItem>
        </Form>
        <Alert
          message="Careful!"
          description="This action may affect the operation of other bots that use this WABA"
          type="warning"
          showIcon
        />
      </Modal>
    </div>
  )
}

export const ChangeCallbackUriModal = Form.create({
  mapPropsToFields: record => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(ChangeCallbackUriComponent))
